import * as React from 'react';
import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import PolylineOutlinedIcon from '@mui/icons-material/PolylineOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ReplayIcon from '@mui/icons-material/Replay';

export function IconLabelButton(props: any) {
  const { disabled, visible, label, iconName, onClick } = props;
  let icon;
  switch (iconName) {
    case 'edit':
      icon = <EditIcon />;
      break;
    case 'delete':
      icon = <DeleteIcon />;
      break;
    case 'lock':
      icon = <LockIcon />;
      break;
    case 'add':
      icon = <AddBoxOutlinedIcon />;
      break;
    case 'drawing':
      icon = <PolylineOutlinedIcon />;
      break;
    case 'load':
      icon = <FileUploadOutlinedIcon />;
      break;
    case 'focus':
      icon = <CenterFocusStrongIcon />;
      break;
    case 'save':
      icon = <SaveAltIcon />;
      break;
    case 'check':
      icon = <CheckOutlinedIcon />;
      break;
    case 'reload':
      icon = <ReplayIcon />;
      break;
    default:
      icon = <LockIcon />;
  }

  if (visible) {
    return label !== null ? (
      <Button
        disabled={disabled}
        size="small"
        // variant="outlined"
        startIcon={icon}
        onClick={onClick}
      >
        {label}
      </Button>
    ) : (
      <IconButton disabled={disabled} size="small" onClick={onClick}>
        {icon}
      </IconButton>
    );
  }
  return null;
}

export function EditToggleButton({
  isLock,
  onClick,
  visible,
  noLabel = false,
}: any) {
  if (isLock) {
    return (
      <IconLabelButton
        visible={visible}
        label={noLabel ? '' : '수정'}
        iconName="edit"
        onClick={onClick}
      />
    );
  }
  return (
    <IconLabelButton
      visible={visible}
      label={noLabel ? '' : '닫기'}
      iconName="lock"
      onClick={onClick}
    />
  );
}
